import API from "./axios"

// create product
export const createProduct = (data) => API.post("/create-product", data)
//get product by public id 
export const getProductById = (id) => API.get(`/get-product-by-id?id=${id}`)
// home products
export const getHomeProducts = () => API.get("/get-products-home")

// single product info
export const getProductInfo = (data) =>
  API.post("/get-product-info", data)

// all products
export const getProducts = () => API.get("/get-products")

// admin products
export const getProductsAdmin = () =>
  API.get("/get-products-admin")

// update product
export const updateProduct = (data) =>
  API.post("/update-product", data)

// delete product
export const deleteProduct = (data) =>
  API.delete("/delete-product", { data })

// check slug
export const checkProductSlug = (data) =>
  API.post("/product-slug-availability", data)


// VARIANTS

export const createVariant = (data) =>
  API.post("/create_variant", data)

export const updateVariant = (data) =>
  API.post("/update_variant", data)

export const deleteVariant = (data) =>
  API.delete("/delete_variant", { data })


// PRODUCT IMAGES

export const uploadProductImages = (data) =>
  API.post("/upload_product_images", data)

export const updateProductImages = (data) =>
  API.post("/update_product_images", data)

export const getImagesByProduct = (data) =>
  API.post("/get_images_by_product", data)

export const getImagesByVariant = (data) =>
  API.post("/get_images_by_variant", data)

export const getImageById = (data) =>
  API.post("/get_image_by_id", data)

export const deleteImageById = (data) =>
  API.delete("/delete_image_by_id", { data })

export const deleteImagesByProduct = (data) =>
  API.delete("/delete_all_images_by_product_id", { data })

export const deleteImagesByVariant = (data) =>
  API.delete("/delete_all_images_by_variant_id", { data })

export const cleanupOrphanImages = () =>
  API.delete("/cleanup_orphan_images")


